import { useState } from 'react';
import TeamDetail from './TeamDetail';
import { FaCircle } from 'react-icons/fa';
import { AiOutlineTrophy } from 'react-icons/ai';
import { MdCalendarToday } from 'react-icons/md';
import moment from 'moment';

import Countdown from './Countdown';

const FixtureItem = ({ fixture }) => {
	const [isLive, setIsLive] = useState(false);

	const utcMoment = moment.utc(fixture.startTime);
	const fixtureDateTime =
		fixture.startTime.slice(0, 10) + 'T' + fixture.startTime.slice(21, 29);
	const tipTime = utcMoment.local().format('HH:mm');
	const twoHoursAgo = moment().subtract(2, 'hours');

	const gameDate = utcMoment.local().format('DD-MM-YY');
	const gameDateSlug = utcMoment.local().format('YYYY-MM-DD');

	const handleClick = () => {
		window.top.location.href =
			fixture?.externalURL ||
			`https://hfl.vercel.app/streams/${fixture.slugRef}/${gameDateSlug}`;
	};

	return (
		<div className='fixture-item' onClick={handleClick}>
			<div className='fixture-item_header'>
				<span className='comp-name'>
					<AiOutlineTrophy size={10} />
					{fixture.season.competition.nameFull}
				</span>
			</div>
			<div className='fixture-item_body'>
				<TeamDetail fixture={fixture} id='0' />
				<div className='fixture-item_detail'>
					<span className='tip-time'>{tipTime}</span>
				</div>
				<TeamDetail fixture={fixture} id='1' />
			</div>
			<div className='fixture-item_footer'>
				<span className='game-date'>
					<MdCalendarToday size={10} />
					{gameDate}
				</span>

				{isLive ? (
					<p className='live-marker'>
						<FaCircle /> <span>LIVE</span>
					</p>
				) : utcMoment.isBefore(twoHoursAgo) ? (
					'ENDED'
				) : (
					<Countdown gameTime={utcMoment} setIsLive={setIsLive} />
				)}
			</div>
		</div>
	);
};

export default FixtureItem;
